<template>
  <div
    ref="ui-carousel"
    class="relative w-full h-full"
  >
    <slot />
    <div class="flex h-full items-center justify-between">
      <div
        class="cursor-pointer z-70"
        @click="prev"
      >
        <slot name="prev" />
      </div>
      <div
        class="cursor-pointer z-70"
        @click="next"
      >
        <slot name="next" />
      </div>
    </div>
    <slot
      name="addons"
      :active-index="activeIndex"
      :item-count="items.length"
    />
  </div>
</template>


<script>
const moveThreshold = 50;


export default {
  data: () => ({
    activeIndex: 0,
    moveStartX: null,
    items: [],
  }),
  mounted() {
    this.$refs['ui-carousel'].addEventListener('touchstart', this.startTouch);
    this.$refs['ui-carousel'].addEventListener('touchmove', this.moveTouch);
    window.addEventListener('resize', this.setItemPositions);
  },
  watch: {
    activeIndex: {
      immediate: true,
      handler(newValue) {
        this.setItemPositions(newValue);
      },
    },
  },
  methods: {
    setActiveItem(index) {
      if (index < 0) {
        this.activeIndex = this.items.length - 1;
      } else if (index >= this.items.length) {
        this.activeIndex = 0;
      } else {
        this.activeIndex = index;
      }
      if (index === this.activeIndex) {
        this.setItemPositions(null, index, true);
      }
    },
    prev() {
      this.setActiveItem(this.activeIndex - 1);
    },
    next() {
      this.setActiveItem(this.activeIndex + 1);
    },
    setItemPositions(event, activeIndex = this.activeIndex, noTransform = false) {
      this.items.forEach((item, index) => {
        item.translateItem(index, activeIndex);
        if (!noTransform) {
          item.setTransformTransitionDuration(0.5);
        }
      });
    },
    updateItems() {
      this.items = this.$children.filter((child) => child.$options.name === 'UICarouselItem');
      this.setActiveItem(0);
    },
    startTouch(e) {
      if (e.touches) {
        this.moveStartX = e.touches[0].clientX;
      } else {
        this.moveStartX = e.screenX;
      }
    },
    moveTouch(e) {
      if (this.moveStartX === null) {
        return;
      }

      let currentX = 0;

      if (e.touches) {
        currentX = e.touches[0].clientX;
      } else {
        currentX = e.screenX;
      }

      const deltaX = this.moveStartX - currentX;

      if (Math.abs(deltaX) < moveThreshold) return;

      if (deltaX > 0) {
        this.next();
      } else {
        this.prev();
      }

      this.moveStartX = null;

      e.preventDefault();
    },
  },
  beforeDestroy() {
    this.$refs['ui-carousel'].removeEventListener('touchstart', this.startTouch);
    this.$refs['ui-carousel'].removeEventListener('touchmove', this.moveTouch);
    window.removeEventListener('resize', this.setItemPositions);
  },
};
</script>
